import { createApi } from '../callApi';
const contentApi = createApi('CONTENT');

export const fetchPsoKeywordSuggestions = (show) => {
    return contentApi({ method: 'GET', target: `/v1/shows/${show}/keywords` });
};
